import * as actions from "../actions/userdata-actions";
import { AppUser } from "../models/utilities/app-user";
import { UserdataModuleState } from "../store/UserdataModuleState";

/**
 * The Userdata Redux Reducer
 * @param state The IApplicationState for this reducer
 * @param action Standard Redux action payload of a type and payload 
 */
export function userdataReducer(state: UserdataModuleState = new UserdataModuleState(), action: IReduxAction) {
    switch (action.type) {
        case actions.SET_USER_INFO: {
            // the service center the user was working in is remembered, so what they may do is what they may do there
            const user = action.payload;
            const working = state.activeServiceCenter && state.activeServiceCenter.name ? state.activeServiceCenter.name : undefined;
            const remembered = !!user && !!user.permissionsByServiceCenter && AppUser.canWorkIn(user.serviceCenters, working);

            return Object.assign({}, state, {
                user: remembered
                    ? { ...user, permissions: AppUser.permissionsIn(user.permissionsByServiceCenter, working) }
                    : user
            });
        }
        case actions.SET_OVERRIDE_PERMISSIONS:
            return Object.assign({}, state, {
                user: {
                    ...state.user,
                    permissions: action.payload
                }
            });
        case actions.SET_USER_SERVICECENTER:
            // what the user may do depends on the service center they are working in
            return Object.assign({}, state, {
                activeServiceCenter: action.payload,
                user: state.user && state.user.permissionsByServiceCenter && action.payload
                    ? { ...state.user, permissions: AppUser.permissionsIn(state.user.permissionsByServiceCenter, action.payload.name) }
                    : state.user
            });
        default:
            return state;
    }
}
